__turbopack_context__.v({
  "backdrop": "modal-popup-module__OHtUMG__backdrop",
  "close": "modal-popup-module__OHtUMG__close",
  "container": "modal-popup-module__OHtUMG__container",
  "content": "modal-popup-module__OHtUMG__content",
  "header": "modal-popup-module__OHtUMG__header",
  "popup": "modal-popup-module__OHtUMG__popup",
  "popupMain": "modal-popup-module__OHtUMG__popupMain",
  "scaleFadeIn": "modal-popup-module__OHtUMG__scaleFadeIn",
  "wrapper": "modal-popup-module__OHtUMG__wrapper",
});
